import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase, Hidden } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_ENDPOINT_URL } from "../../util/api";
import _ from "lodash";
import CircularProgress from "@mui/material/CircularProgress";
import SendIcon from "@mui/icons-material/Send";
import ArticleIcon from "@mui/icons-material/Article";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useContextAuthentication } from "../../util/useContextAuth";
import { useNavigate } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const URLLookup = () => {
  const navigate = useNavigate();
  const contextAuth = useContextAuthentication();

  const valueContext = contextAuth?.value,
  isAdmin=!!valueContext?.isAdmin,
  token=valueContext?.key;

  const [loading, setLoading] = useState(false);
  const [loadingComment, setLoadingComment] = useState(false);
  const [loadingRegisDialog, setLoadingRegisDialog] = useState(false);
  const [showValue, setShowValue] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchTextCommit, setSearchTextCommit] = useState("");
  const [dataLookUp, setDataLookUp] = useState(null);
  const [logId, setLogId] = useState(null);
  const [comment, setComment] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [validateSearch, setValidateSearch] = useState(false);
  const [validateComment, setValidateComment] = useState(false);

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
    setValidateSearch(false)
  };

  const handleSearch = async () => {
    if (searchText === '') {
      setValidateSearch(true)
      return
    }
    setValidateSearch(false)
    setValidateComment(false)
    const params = {
      search: searchText,
    };
    setSearchTextCommit(searchText)
    let data = null;
    const fetchDataLookup = async () => {
      setLoading(true);
      setShowValue(false);
      try {
        const response = await axios.get(`${API_ENDPOINT_URL}/data/lookup/`, {
          params: { ...params },
          headers: { Authorization: `Bearer ${token}` },
          timeout: 600 * 1000, // Set timeout to 600 seconds
        });

        data = response.data.data;

        if (data === null) {
          setLoading(false);
          setShowValue(false);
          setLoadingRegisDialog(true);
         
        } else {
          // If data is not null, set the data and logId in the state
          console.log(data);
          setDataLookUp(data);
          setLoading(false); // Set loading to false when data is received
          setShowValue(true);
        }

        // await axios.post(
        //   `${API_ENDPOINT_URL}/data/lookup-missing/`,
        //   { search: searchText },
        //   { headers: { Authorization: `Bearer ${token}` } }
        // );
      } catch (error) {
        setLoading(false); // Set loading to false on error
        setShowValue(false);
        setAlertSeverity("error");
        setAlertMessage("Register URL Failed");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 4000);
        setShowValue(false);
      }
    };

    const addCommentLog = async (searchText, data) => {
      try {
        const response = await axios.post(
          `${API_ENDPOINT_URL}/data/lookup-log/`,
          { url: searchText, result: data },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const newLogId = response.data.id;
        setLogId(newLogId);
      } catch (error) { }
    };
    // Regular expression for a simple URL validation
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

    // Check if the entered text is a valid URL
    if (!urlRegex.test(searchText)) {
      // Alert if the URL is not valid
      setAlertSeverity("error");
      setAlertMessage("Url is not valid");
      setShowAlert(true);
      addCommentLog(searchText, null)
      setDataLookUp(null);
      setTimeout(() => {
        setShowAlert(false);
      }, 4000);
      setShowValue(false);
      return;
    }
    await fetchDataLookup();
    await addCommentLog(searchText, data);
  };

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // Carry the typed URL over to the Analysis Report screen, and — if a lookup
  // result for that exact URL is already loaded — hand the result data over too
  // so the report shows immediately. If there's no result yet, only the URL is
  // passed and the report auto-runs the search. The report wipes this carry-over
  // after consuming it, so a refresh (F5) there starts blank.
  const handleOpenReport = () => {
    const reportState = { url: searchText };
    if (dataLookUp && searchText === searchTextCommit) {
      reportState.data = dataLookUp;
    }
    navigate("/analysis-report", { state: reportState });
  };

  const handleCloseRegisDialog = () => {
    setLoadingRegisDialog(false);
  };

  const handleCommentSubmit = (comment) => {
    if (comment === '') {
      setValidateComment(true)
      setAlertSeverity("error");
      setAlertMessage("Comment cannot be blank.");
      setShowAlert(true);
        window.scrollTo({ top: 0 });
        setLoading(false)
        setTimeout(() => {
          setShowAlert(false);
      }, 4000); 
      return
    }
    setValidateComment(false)
    if (logId) {
      const apiUrl = `${API_ENDPOINT_URL}/data/lookup-log/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      setLoadingComment(true);
      // Send a PATCH request to update the comment
      axios
        .patch(apiUrl, { comment: comment, log_id: logId }, { headers })
        .then((response) => {
          setComment(""); // Clear comment
          setAlertSeverity("success");
          setAlertMessage("Comment submitted successfully!");
        })
        .catch((error) => {
          setAlertSeverity("error");
          setAlertMessage("Error submitting comment.");
        })
        .finally(() => {
          setShowAlert(true);
          window.scrollTo({ top: 0 });
          setLoadingComment(false)
          setTimeout(() => {
            setShowAlert(false);
          }, 4000); // Hide alert after 4 seconds
        });
    }
  };

  return (
    <>
      {loading ? (
        <CircularProgress
        size={50}
        style={{
          color: 'white',
          position: 'absolute',
          top: '30%',
          left: '48%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999
        }}
      />
      ): (null)}
      
      <Dialog
        open={loading}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
              <DialogTitle id="alert-dialog-title">
                  {"Please wait."}
              </DialogTitle>
              <DialogContent>
                  <DialogContentText id="alert-dialog-description" style={{ whiteSpace: 'pre-line' }}>
                      The search may take several minutes depending on traffic.{'\n'}
                      If the search times out, try searching again after a few minutes.
                  </DialogContentText>
              </DialogContent>
      </Dialog>

      <BootstrapDialog
        // onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={loadingRegisDialog}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Registration Completed!
        </DialogTitle>
        <DialogContent >
          <Typography sx={{ paddingLeft: "20px", paddingRight: "20px" }}>
            Starting phishing detection ...
          </Typography>
          <Typography sx={{ paddingBottom: "50px", paddingLeft: "20px", paddingRight: "100px" }}>
            Please try your search again in 10 minutes.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus sx={{
            backgroundColor: "#2699fb",
            color: "white",
            width: "100px",
            marginRight: "30px",
            marginBottom: "20px",
            "&:hover": {
              backgroundColor: "#3fa1ff", // Change background color on hover to red
            }
          }}
            onClick={handleCloseRegisDialog}
          >
            OK
          </Button>
        </DialogActions>
      </BootstrapDialog>

      <Box
        mt="50px"
        sx={{
          width: "100%",
          display: 'flex',
          padding: '20px 0', // Adjust padding as needed
        }} > </Box>

      {showAlert && (
        <Stack sx={{
          position: "fixed",
          top: "170px", // Adjust the top position as needed
          right: "0px", // Adjust the right position as needed
          zIndex: 9999, // Adjust the zIndex to be higher than other elements
        }} spacing={2}>
          <Alert variant="filled" severity={alertSeverity}>
            {alertMessage}
          </Alert>
        </Stack>
      )}

      <Box
        backgroundColor="#212355"
        sx={{
          marginTop: "-4px",
          width: "100%",
          display: 'flex',
          padding: '20px 0', // Adjust padding as needed
          justifyContent: 'center',
        }}
      >
        <Box sx={{
          width: "60%",
        }}>

          <Grid container>
            <Typography
              fontSize='30px'
              textAlign="left"
              color='#fff'
              fontFamily='"Titillium Web", Arial, Helvetica, sans-serif'
              fontWeight={200}
            >
              PhishDetector
            </Typography>
          </Grid>
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "-4px",
          width: "100%",
          display: 'flex',
          padding: '20px 0', // Adjust padding as needed
          justifyContent: 'center',
        }}
      >
        <Box sx={{
          width: "60%",

        }}>

          <Grid container sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography
              textAlign="left"
              fontFamily='"Titillium Web", Arial, Helvetica, sans-serif'
              fontSize={'18px'}
            >
              Enter a URL for phishing detection.
            </Typography>
            <Button
              variant="contained"
              startIcon={<ArticleIcon />}
              onClick={handleOpenReport}
              sx={{
                backgroundColor: "#2f37a3",
                color: "white",
                fontFamily: '"Titillium Web", Arial, Helvetica, sans-serif',
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#2d2f6b",
                },
              }}
            >
              Analysis Report
            </Button>
          </Grid>
          <Grid container mt={2}>
            <Typography
              textAlign="left"
              fontFamily='"Titillium Web", Arial, Helvetica, sans-serif'
              fontSize={'18px'}
            >
              URL
            </Typography>
          </Grid>
          <Grid container>
            <InputBase
              placeholder="https://domain.xxx.yyy.zzz/path/path"
              onChange={handleSearchTextChange}
              onKeyPress={handleEnter}
              sx={{
                width: "100%",
                height: "34px",
                border: `1px solid ${validateSearch ? 'red' : '#ccc'}`,
                borderRadius: "4px",
                padding: "6px 12px",
                fontSize: "14px",
                lineHeight: 1.42857143,
                color: "#555",
                '::placeholder': {
                  fontFamily: '"Titillium Web", Arial, Helvetica, sans-serif',
                },

              }}
              inputProps={{
                maxLength: 100,
                style: {
                  fontFamily: '"Titillium Web", Arial, Helvetica, sans-serif',
                },
              }}
            />
          </Grid>
          {validateSearch ? (
            <Grid container mt={0}>
              <Typography
                sx={{
                  color: "red",
                  fontFamily:'"Titillium Web", Arial, Helvetica, sans-serif',
                  fontSize: "18px",
                }}
              >
                The url txt field is required.
              </Typography>
            </Grid>
          ) : (null)}
          <Grid container mt={2}>
            <Typography
              sx={{
                padding: "6px 12px",
                cursor: "pointer",
                backgroundColor: "#3a5eac",
                color: "white",
                backgroundImage: "-webkit-linear-gradient(top,#3a5eac,#3c3aac)",
                fontFamily:'"Titillium Web", Arial, Helvetica, sans-serif',
                fontSize: "14px",
              }}
              onClick={handleSearch}
            >
              Search
            </Typography>
          </Grid>
        </Box>
      </Box>


      {!(loading && loadingRegisDialog) && showValue ? (
        <Box
          sx={{
            width: "60%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              borderRadius: "5px",
              padding: "25px 30px 60px",
            }}
          >
            <Grid container>

              <Grid item xs={12} mt={1} >

                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "white",
                    position: "relative",
                  }}
                >
                  <Box width={"100%"}>
                    <Typography fontFamily='"Titillium Web", Arial, Helvetica, sans-serif' color="#6699cc" textAlign="center" fontSize={"1.8em"} fontWeight={400}>
                      Phishing Detection Results for {searchTextCommit}
                    </Typography>
                  </Box>

                </Box>
              </Grid>

              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

                <Grid item lg={6} xs={12} sm={12} md={6} mt={3} >

                  <Box
                    sx={{
                      minHeight: "90px",
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid #2c3e50",
                      position: "relative",
                      borderRadius: "5px 5px 5px 5px",
                    }}
                  >
                    <Box backgroundColor={"#212355"} width={"100%"} borderRadius={"5px 5px 0 0"}>
                      <Typography color="#fff" textAlign="center" lineHeight={"35px"}>
                        Domain Detection
                      </Typography>
                    </Box>
                    <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>
                        {dataLookUp?.urldet?.score != null ? (
                          `score: ${dataLookUp?.urldet?.score}`
                        ) : (
                          <HorizontalRuleIcon />
                        )}
                      </Typography>
                    </Box>
                    <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>
                        {dataLookUp?.urldet?.domain !== undefined ? (
                          `domain: ${dataLookUp?.urldet?.domain}`
                        ) : (
                          <HorizontalRuleIcon />
                        )}
                      </Typography>
                    </Box>
                    <Box width={"100%"} height={"72px"} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>

                      </Typography>
                    </Box>

                  </Box>
                </Grid>


                <Grid item lg={6} xs={12} sm={12} md={6} mt={3}>

                  <Box
                    sx={{
                      minHeight: "90px",
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid #2c3e50",
                      position: "relative",
                      borderRadius: "5px 5px 5px 5px",
                    }}
                  >
                    <Box backgroundColor={"#212355"} width={"100%"} borderRadius={"5px 5px 0 0"}>
                      <Typography color="#fff" textAlign="center" lineHeight={"35px"}>
                        HTML Detection
                      </Typography>
                    </Box>
                    <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>
                        {dataLookUp?.htmldet?.score != null ? (
                          `score: ${dataLookUp?.htmldet?.score}`
                        ) : (
                          `score: 0`
                        )}
                      </Typography>
                    </Box>
                    <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>
                        {dataLookUp?.htmldet?.password_form != null &&
                          dataLookUp?.htmldet?.password_form !== 0
                          ? `Password form: ${dataLookUp?.htmldet?.password_form}`
                          : "Not find password form"}
                      </Typography>
                    </Box>
                    <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>

                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>

                        {dataLookUp?.htmldet?.keyword?.login != null ? (
                          `Keyword Login: ${dataLookUp?.htmldet?.keyword?.login}`
                        ) : (
                          `Not find keyword Login`
                        )}
                      </Typography>
                    </Box>
                    <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>

                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>

                        {dataLookUp?.htmldet?.keyword?.password != null ? (
                          `Keyword Password: ${dataLookUp?.htmldet?.keyword?.password}`
                        ) : (
                          `Not find keyword Password`
                        )}
                      </Typography>
                    </Box>
                    <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>

                      <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>

                        {dataLookUp?.htmldet?.keyword?.authentication != null ? (
                          `Keyword Authentication: ${dataLookUp?.htmldet?.keyword?.authentication}`
                        ) : (
                          `Not find keyword Authentication`
                        )}
                      </Typography>
                    </Box>

                  </Box>
                </Grid>

              </Grid>

              <Grid item lg={12} xs={12} sm={12} md={12} mt={3}>

                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "white",
                    border: "1px solid gray",
                    position: "relative",
                    borderRadius: "5px 5px 5px 5px",
                  }}
                >
                  <Box backgroundColor={"#6699cc"} width={"100%"} borderRadius={"5px 5px 0 0"}>
                    <Typography color="#fff" textAlign="center" lineHeight={"35px"}>
                      Visual Detection
                    </Typography>
                  </Box>
                  <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography sx={{ flexGrow: 1, textAlign: 'center' }}>
                      {dataLookUp?.visual_branddet?.visualdet?.score != null ? (
                        `score: ${dataLookUp?.visual_branddet?.visualdet?.score}`
                      ) : (
                        <HorizontalRuleIcon />
                      )}
                    </Typography>
                  </Box>
                  <Box width={"100%"} sx={{ display: 'flex', alignItems: 'center' }}>

                    <Typography component="div" sx={{ flexGrow: 1, textAlign: 'center' }}>
                      {dataLookUp?.visual_branddet?.visualdet?.path ? (
                        <Box
                          sx={{
                            maxHeight: "620px",
                            backgroundColor: "white",
                            padding: "15px",
                          }}
                        >
                          <Box
                            sx={{
                              minHeight: dataLookUp?.visual_branddet?.visualdet?.path ? "100px" : "400px",
                              backgroundColor: "#f7f7f7",
                              position: "relative",
                              maxHeight: "600px",
                              overflowY: dataLookUp?.visual_branddet?.visualdet?.path ? "scroll" : "auto",
                            }}
                          >
                            <img width="100%" src={dataLookUp?.visual_branddet?.visualdet?.path}></img>
                          </Box>

                        </Box>
                      ) : (
                        <Box
                          sx={{
                            maxHeight: "100px",
                            backgroundColor: "white",
                            padding: "15px",
                          }}
                        ><HorizontalRuleIcon /></Box>

                      )}
                    </Typography>
                  </Box>

                </Box>
              </Grid>



            </Grid>
            <Grid
              item
              lg={12}
              xs={12}
              sm={12}
              md={12}
              mt={5}
            >
              <Typography textAlign="left" sx={{ fontWeight: "bold" }}>
                Comment
              </Typography>
              {/* Comment Textarea */}

              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Type your comment here"
                style={{
                  borderRadius: "5px",
                  width: "100%",
                  padding: "10px",
                  marginTop: "10px",
                  resize: "vertical",
                  border: `1px solid ${validateComment ? 'red' : '#ccc'}`, // Red border when input is blank
                }}
                rows={5} // Adjust the number of rows as needed
                maxLength={500}
              />
            </Grid>
            <Grid item md={2} sx={{ width: "100%", margin: "auto" }}>
              
              {loadingComment ? (
                <Box         
                    sx={{
                      borderRadius: "5px",
                      width: "70px",
                      color: "white", // Set the desired color
                      backgroundColor: "#2699fb", // Set the desired background color
                      height: "40px",
                      cursor: "pointer",
                      float: "right",
                      display: 'flex',         // Use flexbox
                      alignItems: 'center',    // Center items vertically
                      justifyContent: 'center' // Center items horizontally
                    }}
                >
                  
                    <CircularProgress 
                      size={24} 
                      sx={{ color: 'white' }} 
                    />
                  
                </Box>
              ) : (
                <SendIcon
                  style={{
                    borderRadius: "5px",
                    width: "70px",
                    color: "white", // Set the desired color
                    backgroundColor: "#2699fb", // Set the desired background color
                    height: "40px",
                    cursor: "pointer",
                    float: "right",
                  }}
                  onClick={() => handleCommentSubmit(comment)}
                />
              )}
            </Grid>
          </Box>


        </Box>
      ) : (
        ""
      )}
    </>
  );
};

export default URLLookup;
